/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CRMIntegrationType } from './CRMIntegrationType.js';
import {
    CRMIntegrationTypeFromJSON,
    CRMIntegrationTypeFromJSONTyped,
    CRMIntegrationTypeToJSON,
} from './CRMIntegrationType.js';

/**
 * 
 * @export
 * @interface CreateCrmIntegrationRequest
 */
export interface CreateCrmIntegrationRequest {
    /**
     * 
     * @type {any}
     * @memberof CreateCrmIntegrationRequest
     */
    options?: any;
    /**
     * 
     * @type {CRMIntegrationType}
     * @memberof CreateCrmIntegrationRequest
     */
    type?: CRMIntegrationType;
    /**
     * 
     * @type {string}
     * @memberof CreateCrmIntegrationRequest
     */
    inboundScript?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCrmIntegrationRequest
     */
    outboundScript?: string;
}

/**
 * Check if a given object implements the CreateCrmIntegrationRequest interface.
 */
export function instanceOfCreateCrmIntegrationRequest(value: object): boolean {
    return true;
}

export function CreateCrmIntegrationRequestFromJSON(json: any): CreateCrmIntegrationRequest {
    return CreateCrmIntegrationRequestFromJSONTyped(json, false);
}

export function CreateCrmIntegrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCrmIntegrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'options': json['options'] == null ? undefined : json['options'],
        'type': json['type'] == null ? undefined : CRMIntegrationTypeFromJSON(json['type']),
        'inboundScript': json['inboundScript'] == null ? undefined : json['inboundScript'],
        'outboundScript': json['outboundScript'] == null ? undefined : json['outboundScript'],
    };
}

export function CreateCrmIntegrationRequestToJSON(value?: CreateCrmIntegrationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'options': value['options'],
        'type': CRMIntegrationTypeToJSON(value['type']),
        'inboundScript': value['inboundScript'],
        'outboundScript': value['outboundScript'],
    };
}

